import React from 'react';
import styled from 'styled-components';

import { BankOutlineIcon } from 'src/assets/bank-outline-icon';
import { CoinDepositIcon } from 'src/assets/coin-deposit-icon';
import { PhoneBankIcon } from 'src/assets/phone-bank-icon';
import {
  StepsList,
  Step,
  StepContent,
} from 'src/payments/components/incentive-accordion-styles/incentive-accordion-styles';
import { Typography } from 'src/typography';

type PointsBoostDetailsProps = {
  // Display label from the points-boost foundation (e.g. "2x"); never a dollar amount.
  multiplierLabel: string;
  paymentStepText?: string;
};

// Points surfaces deliberately carry no full-terms link (owner copy decision); the accordion
// details are the three explanatory steps only.
export const PointsBoostDetails = ({
  multiplierLabel,
  paymentStepText = 'Pay at checkout with your bank',
}: PointsBoostDetailsProps): JSX.Element => (
  <div>
    <StepsList>
      <Step>
        <BankOutlineIcon />
        <StepContent>1. Link your bank.</StepContent>
      </Step>
      <Step>
        <PhoneBankIcon />
        <StepContent>2. {paymentStepText}.</StepContent>
      </Step>
      <Step>
        <CoinDepositIcon />
        <StepContent>3. Get {multiplierLabel} rewards.</StepContent>
      </Step>
    </StepsList>
    <Terms size='small'>
      Your {multiplierLabel} rewards are calculated on your full order total after discounts, when you pay with Pay by
      Bank. If you qualify for more than one rewards boost, you'll get the highest one. Rewards boosts can't be
      combined. Eligibility requirements apply.
    </Terms>
  </div>
);

const Terms = styled(Typography.Label)`
  margin-top: ${({ theme }) => theme.spaces[4]};
`;
